import React from 'react';
import { Container } from 'components/UI';
import { Title } from '@landing/ui';

import * as styles from './EventLocations.module.scss';
import LocationCard from './LocationCard';

export default function EventLocations({ title, subtitle, items }) {
  return (
    <Container className={styles.container} id="event-locations" background="transparent">
      <div className={styles.layout}>
        <Title color="white">{title}</Title>
        <p className={styles.subtitle}>{subtitle}</p>
        <div className={styles.eventsWrapper}>
          {items.map(item => (
            <LocationCard key={item.title} {...item} />
          ))}
        </div>
      </div>
    </Container>
  );
}
